import React from 'react';
import AnimatedCounter from './AnimatedCounter';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a Computer Science student at the University of Texas at Austin (Expected May 2027) 
              specializing in machine learning, distributed systems, and software engineering. 
              I've had the opportunity to work on cutting-edge ML infrastructure at Amazon's Nova AGI team, 
              optimizing large-scale training pipelines and implementing hyperparameter optimization systems.
            </p>
            <p>
              My experience spans from building ML models and deploying cloud services to developing 
              full-stack applications. I'm passionate about solving complex problems at scale, whether 
              it's optimizing GPU utilization in distributed training or building production-ready 
              systems. Currently exploring neural networks, NLP, and computer vision while contributing 
              to ACM and UT Programming Club.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-number">
                  <AnimatedCounter end={4} suffix="+" />
                </div>
                <div className="stat-label">Internships</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  <AnimatedCounter end={20} suffix="+" />
                </div>
                <div className="stat-label">Technologies</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  <AnimatedCounter end={15} suffix="+" />
                </div>
                <div className="stat-label">Projects</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

